module.exports = __webpack_public_path__ + "weather.037c3dc9a7f8eab7af77.ttf";


//////////////////
// WEBPACK FOOTER
// C:/Users/INMOGR/Desktop/Angular Project/src/assets/fonts/line-icons-pro/weather/webfont/weather.ttf
// module id = ../../../../../src/assets/fonts/line-icons-pro/weather/webfont/weather.ttf
// module chunks = styles